export const LOCAL_STORAGE_KEYS = {
  ORIS: 'mp-oris',
  OFFICERS: (oriId) => `mp-${oriId}-officers`,
  OPEN_INCIDENTS: (userId) => `${userId}-open-incidents`,
}; 